import { ca } from '@cian/analytics';

import { IOfferSchema } from 'shared/repositories/commercial-search-offers/entities/offer/OfferSchema';
import { getAnalyticsProducts } from 'shared/utils/analytics/getAnalyticsProducts';

export function trackMoreButtonClick(offers: IOfferSchema[]): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'infite_search',
    label: 'more',
    name: 'oldevent',
    products: getAnalyticsProducts({ offers }),
  });
}

export function trackOtherCardsShow(offers: IOfferSchema[]): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'infite_search',
    name: 'oldevent',
    products: getAnalyticsProducts({ offers }),
  });
}

export function trackOtherCardsLoaded(offers: IOfferSchema[]): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'infite_search',
    label: 'more',
    name: 'oldevent',
    products: getAnalyticsProducts({ offers }),
  });
}
